import { styled, height, background, overflow } from '@vebox/etui-system';
import { mediaMax } from '../utilities/responsive.js';
import '../utilities/omit.js';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { Component, createElement, Fragment } from 'react';
import '../utilities/get-styleprop.js';
import { _ as _objectWithoutProperties, a as _objectSpread2, c as _defineProperty, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Span } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../Spinner/Spinner.js';
import '../utils-fabc7ae7.js';
import 'react-dom';
import { Spring } from 'react-spring/renderprops.cjs';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import '../Button/Button.js';
import '../Checkbox/CheckboxBase.js';
import '../Checkbox/CheckboxCircle.js';
import '../Checkbox/utils.js';
import '../Checkbox/Checkbox.js';
import 'element-resize-detector';
import ContainerDimensions from '../ContainerDimensions/ContainerDimensions.js';
import '../Pagination/Pager.js';
import Pagination from '../Pagination/Pagination.js';
import RcTable from 'rc-table';
import '../Td-2423cb3a.js';
import './createBodyRow.js';
import './createHeaderCell.js';
import TableLoader from './TableLoader.js';
import 'react-resizable';
import './createBodyCell.js';
import { normalizeColumns, hasResizableColumns, updateResizableColumnWidth, isTheSameComponents, createComponents, getRowSelection, stopPropagation, getCurrentBreakpoint, isSameColumn, flatArray, flatFilter, treeMap } from './utils/index.js';
import Column from './Column.js';
import SelectionBox from './SelectionBox.js';
import SelectionCheckboxAll from './SelectionCheckboxAll.js';
import { getRowKey } from './utils/get-row-key.js';

const TableWrapperDiv = styled(Div)`
  &:before,
  &:after {
    display: table;
    content: ' ';
    box-sizing: border-box;
  }

  &:after {
    clear: both;
  }

  position: relative;
  height: 100%;
  width: 100%;
`;

const _excluded = ["containerHeight", "isPaginationRendered"];
const prefixCls = 'danfoss-table';
const Table = styled(RcTable).attrs(_ref => {
  let {
      containerHeight,
      isPaginationRendered
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    position: 'relative',
    overflow: 'auto',
    height: isPaginationRendered ? `calc(${containerHeight}px - 50px)` : '100%'
  }, props);
})`
  ${height};
  ${background};
  ${overflow};

  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    text-align: left;
  }

  .${prefixCls}-container {
    min-width: ${({
  minWidth = 'auto'
}) => minWidth};
  }

  .${prefixCls}-placeholder {
    text-align: center;
  }

  .${prefixCls}-scroll {
    overflow: auto;
    overflow-x: hidden;
    position: relative;
  }

  .${prefixCls}-has-fix-left {
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    transition: box-shadow 0.3s ease;
    box-shadow: 6px 2px 6px -4px rgba(0, 0, 0, 0.15);
    background-color: ${({
  theme
}) => theme.palette.common.white};
  }

  .${prefixCls}-row-expand-icon-cell {
    width: 42px;
    text-align: center;
  }

  .${prefixCls}-row-expand-icon, .${prefixCls}-expanded-row-expand-icon {
    cursor: pointer;
    width: 10px;
    height: 10px;
    text-align: center;
    user-select: none;
    border: solid ${({
  theme
}) => theme.palette.divider};
    border-width: 0 2px 2px 0;
    display: inline-block;
  }

  .${prefixCls}-row-expand-icon.${prefixCls}-row-collapsed {
    transform: rotate(-45deg);
  }

  .${prefixCls}-row-expand-icon.${prefixCls}-row-expanded {
    transform: rotate(45deg);
  }
`;

const SortColumnSpan = styled(Span)`
  display: flex;
  position: relative;
  align-items: center;
`;

const SortTriggerDiv = styled(Div)`
  display: block;
  position: relative;
  height: 16px;
  width: 16px;
  line-height: 0;

  ${({
  theme
}) => mediaMax(theme).xs`
    display: none;
  `};
`;

const SortTextSpan = styled(Span)`
  line-height: 1;
  user-select: none;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const _excluded$1 = ["theme"];
const PaginationDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return _objectSpread2({
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bottom: 0,
    bg: theme.palette.common.white,
    height: '50px',
    width: '100%',
    borderTop: `1px solid ${theme.palette.divider}`
  }, props);
})``;

const _excluded$2 = ["loading", "width", "emptyPlaceholder", "onExpandedRowsChange", "expandedRowRender", "expandRowByClick", "defaultExpandedRowKeys", "styles", "theme"];
const defaultPagination = {
  onChange: () => ({})
};
const emptyObject = {};
class BaseTable extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      prevProps
    } = prevState;
    let columns = nextProps.columns || normalizeColumns(nextProps.children);
    if (hasResizableColumns(columns)) {
      columns = updateResizableColumnWidth(nextProps.columns, prevState.columns);
    }
    let nextState = _objectSpread2(_objectSpread2({}, prevState), {}, {
      prevProps: nextProps,
      columns
    });
    if (nextProps.pagination || prevProps.pagination) {
      const newPagination = _objectSpread2(_objectSpread2(_objectSpread2({}, defaultPagination), prevState.pagination), nextProps.pagination);
      newPagination.current = newPagination.current || 1;
      newPagination.pageSize = newPagination.pageSize || 10;
      nextState = _objectSpread2(_objectSpread2({}, nextState), {}, {
        pagination: nextProps.pagination !== false ? newPagination : emptyObject
      });
    }
    if (nextProps.rowSelection && nextProps.rowSelection.selectedRowKeys) {
      nextProps.store.setState({
        selectedRowKeys: nextProps.rowSelection.selectedRowKeys || []
      });
    } else if (prevProps.rowSelection && !nextProps.rowSelection) {
      nextProps.store.setState({
        selectedRowKeys: []
      });
    }
    if (nextProps.dataSource && nextProps.dataSource !== prevProps.dataSource) {
      nextProps.store.setState({
        selectionDirty: false
      });
    }
    nextProps.setCheckboxPropsCache({});
    if (!isTheSameComponents(nextProps.components, prevProps.components)) {
      const components = createComponents(nextProps.components, nextProps.styles);
      nextState = _objectSpread2(_objectSpread2({}, nextState), {}, {
        components
      });
    }
    return nextState;
  }
  constructor(_props) {
    super(_props);
    _defineProperty(this, "getCheckboxPropsByItem", (item, index) => {
      const rowSelection = getRowSelection(this.props);
      if (!rowSelection.getCheckboxProps) {
        return {};
      }
      const key = this.getRecordKey(item, index);
      // Cache checkboxProps
      if (!this.props.checkboxPropsCache[key]) {
        this.props.checkboxPropsCache[key] = rowSelection.getCheckboxProps(item) || {};
      }
      return this.props.checkboxPropsCache[key];
    });
    _defineProperty(this, "onRow", (record, index) => {
      const {
        onRow,
        store
      } = this.props;
      const custom = onRow ? onRow(record, index) : {};
      return _objectSpread2(_objectSpread2({}, custom), {}, {
        store,
        rowKey: this.getRecordKey(record, index)
      });
    });
    _defineProperty(this, "getRecordKey", (record, index) => {
      const {
        rowKey
      } = this.props;
      return getRowKey(record, index, rowKey);
    });
    _defineProperty(this, "handleSelect", (record, rowIndex, e) => {
      const {
        checked
      } = e.target;
      const {
        nativeEvent
      } = e;
      const defaultSelection = this.props.store.getState().selectionDirty ? [] : this.getDefaultSelection();
      let selectedRowKeys = this.props.store.getState().selectedRowKeys.concat(defaultSelection);
      const key = this.getRecordKey(record, rowIndex);
      const {
        pivot
      } = this.state;
      const rows = this.getFlatCurrentPageData();
      let realIndex = rowIndex;
      if (this.props.expandedRowRender) {
        realIndex = rows.findIndex(row => this.getRecordKey(row, rowIndex) === key);
      }

      // @ts-expect-error
      if (nativeEvent.shiftKey && pivot !== undefined && realIndex !== pivot) {
        const changeRowKeys = [];
        const direction = Math.sign(pivot - realIndex);
        const dist = Math.abs(pivot - realIndex);
        let step = 0;
        while (step <= dist) {
          const i = realIndex + step * direction;
          step += 1;
          const row = rows[i];
          const rowKey = this.getRecordKey(row, i);
          const checkboxProps = this.getCheckboxPropsByItem(row, i);
          if (!checkboxProps.disabled) {
            if (selectedRowKeys.includes(rowKey)) {
              if (!checked) {
                selectedRowKeys = selectedRowKeys.filter(j => rowKey !== j);
                changeRowKeys.push(rowKey);
              }
            } else if (checked) {
              selectedRowKeys.push(rowKey);
              changeRowKeys.push(rowKey);
            }
          }
        }
        this.setState({
          pivot: realIndex
        });
        this.props.store.setState({
          selectionDirty: true
        });
        this.setSelectedRowKeys(selectedRowKeys, {
          record,
          checked,
          changeRowKeys,
          nativeEvent,
          selectWay: 'onSelectMultiple'
        });
      } else {
        if (checked) {
          selectedRowKeys.push(this.getRecordKey(record, realIndex));
        } else {
          selectedRowKeys = selectedRowKeys.filter(i => key !== i);
        }
        this.setState({
          pivot: realIndex
        });
        this.props.store.setState({
          selectionDirty: true
        });
        this.setSelectedRowKeys(selectedRowKeys, {
          record,
          checked,
          nativeEvent,
          changeRowKeys: undefined,
          selectWay: 'onSelect'
        });
      }
    });
    _defineProperty(this, "handleRadioSelect", (record, rowIndex, e) => {
      const {
        checked
      } = e.target;
      const {
        nativeEvent
      } = e;
      const key = this.getRecordKey(record, rowIndex);
      const selectedRowKeys = [key];
      this.props.store.setState({
        selectionDirty: true
      });
      this.setSelectedRowKeys(selectedRowKeys, {
        record,
        checked,
        nativeEvent,
        selectWay: 'onSelect',
        changeRowKeys: undefined
      });
    });
    _defineProperty(this, "handleSelectRow", (selectionKey, index, onSelectFunc
    // eslint-disable-next-line consistent-return
    ) => {
      const data = this.getFlatCurrentPageData();
      const defaultSelection = this.props.store.getState().selectionDirty ? [] : this.getDefaultSelection();
      const selectedRowKeys = this.props.store.getState().selectedRowKeys.concat(defaultSelection);
      const changeableRowKeys = data.filter((item, i) => !this.getCheckboxPropsByItem(item, i).disabled).map((item, i) => this.getRecordKey(item, i));
      const changeRowKeys = [];
      let selectWay = 'onSelectAll';
      let checked;
      // handle default selection
      switch (selectionKey) {
        case 'all':
          changeableRowKeys.forEach(key => {
            if (selectedRowKeys.indexOf(key) < 0) {
              selectedRowKeys.push(key);
              changeRowKeys.push(key);
            }
          });
          selectWay = 'onSelectAll';
          checked = true;
          break;
        case 'removeAll':
          changeableRowKeys.forEach(key => {
            if (selectedRowKeys.indexOf(key) >= 0) {
              selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
              changeRowKeys.push(key);
            }
          });
          selectWay = 'onSelectAll';
          checked = false;
          break;
        case 'invert':
          changeableRowKeys.forEach(key => {
            if (selectedRowKeys.indexOf(key) < 0) {
              selectedRowKeys.push(key);
            } else {
              selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
            }
            changeRowKeys.push(key);
            selectWay = 'onSelectInvert';
          });
          break;
      }
      this.props.store.setState({
        selectionDirty: true
      });
      const {
        rowSelection
      } = this.props;
      let customSelectionStartIndex = 2;
      if (rowSelection && rowSelection.hideDefaultSelections) {
        customSelectionStartIndex = 0;
      }
      if (index >= customSelectionStartIndex && typeof onSelectFunc === 'function') {
        return onSelectFunc(changeableRowKeys);
      }
      this.setSelectedRowKeys(selectedRowKeys, {
        selectWay,
        checked,
        changeRowKeys
      });
    });
    _defineProperty(this, "handlePageChange", (current, ...otherArguments) => {
      const {
        props
      } = this;
      const pagination = _objectSpread2({}, this.state.pagination);
      pagination.current = current || pagination.current || 1;
      pagination.onChange(pagination.current, ...otherArguments);
      const newState = {
        pagination
      };
      // Controlled current prop will not respond user interaction
      if (props.pagination && typeof props.pagination === 'object' && 'current' in props.pagination) {
        newState.pagination = _objectSpread2(_objectSpread2({}, pagination), {}, {
          current: this.state.pagination.current
        });
      }
      this.setState(newState);
      this.props.store.setState({
        selectionDirty: false
      });
      const {
        onChange
      } = this.props;
      if (onChange) {
        // eslint-disable-next-line prefer-spread
        onChange.apply(null, this.prepareParamsArguments(_objectSpread2(_objectSpread2({
          pagination
        }, this.state), {}, {
          selectionDirty: false
        })));
      }
    });
    _defineProperty(this, "handleResize", index => (_event, {
      size
    }) => {
      this.setState(({
        columns
      }) => {
        const nextColumns = [...columns];
        nextColumns[index] = _objectSpread2(_objectSpread2({}, nextColumns[index]), {}, {
          width: size.width
        });
        return {
          columns: nextColumns
        };
      });
    });
    _defineProperty(this, "renderSelectionBox", type =>
    // eslint-disable-next-line react/display-name
    (_, record, index) => {
      const rowKey = this.getRecordKey(record, index);
      const props = this.getCheckboxPropsByItem(record, index);
      const handleChange = e => {
        type === 'radio' ? this.handleRadioSelect(record, index, e) : this.handleSelect(record, index, e);
      };
      return /*#__PURE__*/createElement("span", {
        role: "button",
        tabIndex: 0,
        onClick: stopPropagation
      }, /*#__PURE__*/createElement(SelectionBox, _extends({
        type: type,
        store: this.props.store,
        rowIndex: rowKey,
        onChange: handleChange,
        defaultSelection: this.getDefaultSelection()
      }, props)));
    });
    _defineProperty(this, "renderTable", (height, isPaginationRendered) => {
      const _this$props = this.props,
        {
          loading,
          width,
          emptyPlaceholder,
          onExpandedRowsChange,
          expandedRowRender,
          expandRowByClick,
          defaultExpandedRowKeys,
          styles,
          theme
        } = _this$props,
        restProps = _objectWithoutProperties(_this$props, _excluded$2);
      const currentBreakpoint = getCurrentBreakpoint(width, theme);
      const data = this.getCurrentPageData();
      const emptyTablePlaceholder = loading ? /*#__PURE__*/createElement(TableLoader, {
        height: height
      }) : emptyPlaceholder;
      let columns = this.renderRowSelection();
      columns = this.renderColumns(columns);
      columns = columns.map((column, i) => {
        const newColumn = _objectSpread2({}, column);
        newColumn.key = this.getColumnKey(newColumn, i);
        newColumn.title = this.getColumnTitle(newColumn);
        return newColumn;
      });
      columns = columns.filter(column => {
        if (column.columnBreakpoints && column.columnBreakpoints.length) {
          return column.columnBreakpoints.indexOf(currentBreakpoint) !== -1;
        }
        return true;
      });
      return /*#__PURE__*/createElement(Table, _extends({
        key: "table"
      }, styles.root, restProps, {
        onRow: this.onRow,
        components: this.state.components,
        data: data,
        columns: columns,
        emptyText: emptyTablePlaceholder,
        expandable: {
          defaultExpandedRowKeys,
          expandedRowRender,
          onExpandedRowsChange,
          expandRowByClick
        },
        expandIconAsCell: expandedRowRender && !expandRowByClick ? true : null,
        containerHeight: height,
        isPaginationRendered: isPaginationRendered
      }));
    });
    const _columns = this.props.columns || normalizeColumns(this.props.children);
    this.state = _objectSpread2(_objectSpread2({}, this.getDefaultSortOrder(_columns || [])), {}, {
      pagination: this.getDefaultPagination(_props),
      pivot: undefined,
      prevProps: _props,
      components: createComponents(_props.components, _props.styles),
      columns: _columns
    });
  }
  componentDidUpdate() {
    const {
      columns,
      sortColumn,
      sortOrder
    } = this.state;
    if (this.getSortOrderColumns(columns).length > 0) {
      const sortState = this.getSortStateFromColumns(columns);
      if (!isSameColumn(sortState.sortColumn, sortColumn) || sortState.sortOrder !== sortOrder) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState(sortState);
      }
    }
  }
  getDefaultSelection() {
    const rowSelection = getRowSelection(this.props);
    if (!rowSelection.getCheckboxProps) {
      return [];
    }
    return this.getFlatData().filter((item, rowIndex) => this.getCheckboxPropsByItem(item, rowIndex).defaultChecked).map((record, rowIndex) => this.getRecordKey(record, rowIndex));
  }
  getDefaultPagination(props) {
    const pagination = props.pagination || {};
    return this.hasPagination(props) ? _objectSpread2(_objectSpread2(_objectSpread2({}, defaultPagination), pagination), {}, {
      current: pagination.defaultCurrent || pagination.current || 1,
      pageSize: pagination.defaultPageSize || pagination.pageSize || 10
    }) : {};
  }
  setSelectedRowKeys(selectedRowKeys, selectionInfo) {
    const {
      selectWay,
      record,
      checked,
      changeRowKeys,
      nativeEvent
    } = selectionInfo;
    const rowSelection = getRowSelection(this.props);
    if (rowSelection && !('selectedRowKeys' in rowSelection)) {
      this.props.store.setState({
        selectedRowKeys
      });
    }
    const data = this.getFlatData();
    if (!rowSelection.onChange && !rowSelection[selectWay]) {
      return;
    }
    const selectedRows = data.filter((row, i) => selectedRowKeys.indexOf(this.getRecordKey(row, i)) >= 0);
    if (rowSelection.onChange) {
      rowSelection.onChange(selectedRowKeys, selectedRows);
    }
    if (selectWay === 'onSelect' && rowSelection.onSelect) {
      rowSelection.onSelect(record, checked, selectedRows, nativeEvent);
    } else if (selectWay === 'onSelectMultiple' && rowSelection.onSelectMultiple) {
      const changeRows = data.filter((row, i) => changeRowKeys.indexOf(this.getRecordKey(row, i)) >= 0);
      rowSelection.onSelectMultiple(checked, selectedRows, changeRows);
    } else if (selectWay === 'onSelectAll' && rowSelection.onSelectAll) {
      const changeRows = data.filter((row, i) => changeRowKeys.indexOf(this.getRecordKey(row, i)) >= 0);
      rowSelection.onSelectAll(checked, selectedRows, changeRows);
    } else if (selectWay === 'onSelectInvert' && rowSelection.onSelectInvert) {
      rowSelection.onSelectInvert(selectedRowKeys);
    }
  }
  getLocalData(state) {
    const currentState = state || this.state;
    const {
      dataSource
    } = this.props;
    const sorterFn = this.getSorterFn(currentState);
    let data = dataSource || [];
    data = data.slice(0);
    if (sorterFn) {
      data = this.recursiveSort(data, sorterFn);
    }
    return data;
  }
  getFlatData() {
    const {
      childrenColumnName
    } = this.props;
    return flatArray(this.getLocalData(null), childrenColumnName);
  }
  getFlatCurrentPageData() {
    const {
      childrenColumnName
    } = this.props;
    return flatArray(this.getCurrentPageData(), childrenColumnName);
  }
  getSortOrderColumns(columns) {
    return flatFilter(columns || (this.state || {}).columns || [], column => 'sortOrder' in column);
  }
  getDefaultSortOrder(columns) {
    const definedSortState = this.getSortStateFromColumns(columns);
    const defaultSortedColumn = flatFilter(columns || [], column => column.defaultSortOrder != null)[0];
    if (defaultSortedColumn && !definedSortState.sortColumn) {
      return {
        sortColumn: defaultSortedColumn,
        sortOrder: defaultSortedColumn.defaultSortOrder
      };
    }
    return definedSortState;
  }
  getSortStateFromColumns(columns) {
    // return first column which sortOrder is not falsy
    const sortedColumn = this.getSortOrderColumns(columns).filter(col => col.sortOrder)[0];
    if (sortedColumn) {
      return {
        sortColumn: sortedColumn,
        sortOrder: sortedColumn.sortOrder
      };
    }
    return {
      sortColumn: null,
      sortOrder: null
    };
  }
  getSorterFn(state) {
    const {
      sortOrder,
      sortColumn
    } = state || this.state;
    if (!sortOrder || !sortColumn || typeof sortColumn.sorter !== 'function') {
      return null;
    }

    // eslint-disable-next-line consistent-return
    return (a, b) => {
      const result = sortColumn.sorter(a, b);
      if (result !== 0) {
        return sortOrder === 'descend' ? -result : result;
      }
      return 0;
    };
  }
  // eslint-disable-next-line class-methods-use-this
  getColumnKey(column, index) {
    return column.key || column.dataIndex || index;
  }
  getColumnTitle(column) {
    const currentBreakpoint = getCurrentBreakpoint(this.props.width, this.props.theme);
    if (column.titleBreakpoints && column.titleBreakpoints.length) {
      const showTitle = column.titleBreakpoints.indexOf(currentBreakpoint) !== -1;
      return showTitle ? column.title : '';
    }
    return column.title;
  }
  getMaxCurrent(total) {
    const {
      current,
      pageSize
    } = this.state.pagination;
    if ((current - 1) * pageSize >= total) {
      return Math.floor((total - 1) / pageSize) + 1;
    }
    return current;
  }
  getCurrentPageData() {
    let data = this.getLocalData();
    let current;
    let pageSize;
    const {
      state
    } = this;
    if (!this.hasPagination()) {
      pageSize = Number.MAX_VALUE;
      current = 1;
    } else {
      pageSize = state.pagination.pageSize;
      current = this.getMaxCurrent(state.pagination.total || data.length);
    }
    if (data.length > pageSize || pageSize === Number.MAX_VALUE) {
      data = data.filter((_, i) => {
        return i >= (current - 1) * pageSize && i < current * pageSize;
      });
    }
    return data;
  }
  isSortColumn(column) {
    const {
      sortColumn
    } = this.state;
    if (!column || !sortColumn) {
      return false;
    }
    return this.getColumnKey(sortColumn) === this.getColumnKey(column);
  }

  // Get pagination, sorter
  prepareParamsArguments(state) {
    const pagination = _objectSpread2({}, state.pagination);
    // remove useless handle function in Table.onChange
    delete pagination.onChange;
    delete pagination.onShowSizeChange;
    const sorter = {};
    if (state.sortColumn && state.sortOrder) {
      sorter.column = state.sortColumn;
      sorter.order = state.sortOrder;
      sorter.field = state.sortColumn.dataIndex;
      sorter.columnKey = this.getColumnKey(state.sortColumn);
    }
    return [pagination, sorter];
  }
  findColumn(myKey) {
    let column;
    treeMap(this.state.columns, c => {
      if (this.getColumnKey(c) === myKey) {
        column = c;
      }
    });
    return column;
  }
  recursiveSort(data, sorterFn) {
    const {
      childrenColumnName = 'children'
    } = this.props;
    return data.sort(sorterFn).map(item => item[childrenColumnName] ? _objectSpread2(_objectSpread2({}, item), {}, {
      [childrenColumnName]: this.recursiveSort(item[childrenColumnName], sorterFn)
    }) : item);
  }
  toggleSortOrder(column) {
    if (!column.sorter) {
      return;
    }
    const sortDirections = column.sortDirections || this.props.sortDirections;
    const {
      sortOrder,
      sortColumn
    } = this.state;
    let newSortOrder;
    if (isSameColumn(sortColumn, column) && sortOrder !== undefined) {
      const methodIndex = sortDirections.indexOf(sortOrder) + 1;
      newSortOrder = methodIndex === sortDirections.length ? undefined : sortDirections[methodIndex];
    } else {
      // eslint-disable-next-line prefer-destructuring
      newSortOrder = sortDirections[0];
    }
    const newState = {
      sortOrder: newSortOrder,
      sortColumn: newSortOrder ? column : null
    };

    // Controlled
    if (this.getSortOrderColumns().length === 0) {
      this.setState(newState);
    }
    const {
      onChange
    } = this.props;
    if (onChange) {
      // eslint-disable-next-line prefer-spread
      onChange.apply(null, this.prepareParamsArguments(_objectSpread2(_objectSpread2({}, this.state), newState)));
    }
  }
  hasPagination(props) {
    const pagination = props || this.props.pagination;
    if (pagination === false) {
      return false;
    }
    return true;
  }
  renderColumns(columns) {
    const {
      sortOrder
    } = this.state;
    return treeMap(columns, (originColumn, i) => {
      const column = _objectSpread2({}, originColumn);
      const key = this.getColumnKey(column, i);
      let sortButton;
      let {
        onHeaderCell
      } = column;
      let sortingIsActive = false;
      if (column.sorter) {
        const isSortColumn = this.isSortColumn(column);
        const sortDirections = column.sortDirections || this.props.sortDirections;
        const isAscend = isSortColumn && sortOrder === 'ascend' && sortDirections.indexOf('ascend') !== -1;
        const isDescend = isSortColumn && sortOrder === 'descend' && sortDirections.indexOf('descend') !== -1;
        sortingIsActive = isAscend || isDescend;
        const ascend = opacity => isAscend && sortDirections.indexOf('ascend') !== -1 && /*#__PURE__*/createElement(Icon, {
          role: "button",
          size: 16,
          glyph: icons.ARROW_UP,
          styles: {
            root: {
              opacity
            }
          }
        });
        const descend = opacity => isDescend && sortDirections.indexOf('descend') !== -1 && /*#__PURE__*/createElement(Icon, {
          role: "button",
          size: 16,
          glyph: icons.ARROW_DOWN,
          styles: {
            root: {
              opacity
            }
          }
        });
        sortButton = /*#__PURE__*/createElement(SortTriggerDiv, null, sortingIsActive && /*#__PURE__*/createElement(Spring, {
          from: {
            opacity: 0
          },
          to: {
            opacity: 1
          }
        }, ({
          opacity
        }) => /*#__PURE__*/createElement(Fragment, null, ascend(opacity), descend(opacity))));
        onHeaderCell = col => {
          let colProps = {};
          if (column.onHeaderCell) {
            colProps = _objectSpread2({}, column.onHeaderCell(col));
          }
          const onHeaderCellClick = colProps.onClick;
          colProps.onClick = (...args) => {
            this.toggleSortOrder(column);
            if (onHeaderCellClick) {
              onHeaderCellClick(...args);
            }
          };
          return colProps;
        };
      } else {
        onHeaderCell = col => {
          let colProps = {};
          if (column.onHeaderCell) {
            colProps = _objectSpread2(_objectSpread2({}, column.onHeaderCell(col)), {}, {
              width: column.width,
              onResize: this.handleResize(i)
            });
          }
          return colProps;
        };
      }
      return _objectSpread2(_objectSpread2({}, column), {}, {
        onHeaderCell,
        title: [/*#__PURE__*/createElement(SortColumnSpan, {
          key: key
        }, /*#__PURE__*/createElement(SortTextSpan, {
          title: column.title
        }, column.title), sortButton)]
      });
    });
  }
  renderPagination() {
    if (!this.hasPagination()) {
      return null;
    }
    const {
      pagination
    } = this.state;
    const total = pagination.total || this.getLocalData().length;
    return total > 0 ? /*#__PURE__*/createElement(PaginationDiv, this.props.styles.pagination, /*#__PURE__*/createElement(Pagination, _extends({}, pagination, {
      onChange: this.handlePageChange,
      total: total,
      current: this.getMaxCurrent(total)
    }))) : null;
  }
  renderRowSelection() {
    const {
      rowSelection,
      disableHeaderCheckBox
    } = this.props;
    const columns = this.state.columns.concat();
    if (rowSelection) {
      const data = this.getFlatCurrentPageData().filter((item, index) => {
        if (rowSelection.getCheckboxProps) {
          return !this.getCheckboxPropsByItem(item, index).disabled;
        }
        return true;
      });
      const selectionColumn = {
        key: 'selection-column',
        render: this.renderSelectionBox(rowSelection.type),
        fixed: rowSelection.fixed,
        width: rowSelection.columnWidth,
        title: rowSelection.columnTitle
      };
      if (rowSelection.type !== 'radio') {
        const checkboxAllDisabled = data.every((item, index) => this.getCheckboxPropsByItem(item, index).disabled);
        selectionColumn.title = selectionColumn.title || !disableHeaderCheckBox && /*#__PURE__*/createElement(SelectionCheckboxAll, {
          store: this.props.store,
          data: data,
          getCheckboxPropsByItem: this.getCheckboxPropsByItem,
          getRecordKey: this.getRecordKey,
          disabled: checkboxAllDisabled,
          onSelect: this.handleSelectRow,
          selections: rowSelection.selections,
          hideDefaultSelections: rowSelection.hideDefaultSelections
        });
      }
      if ('fixed' in rowSelection) {
        selectionColumn.fixed = rowSelection.fixed;
      } else if (columns.some(column => column.fixed === 'left' || column.fixed === true)) {
        selectionColumn.fixed = 'left';
      }
      if (columns[0] && columns[0].key === 'selection-column') {
        columns[0] = selectionColumn;
      } else {
        columns.unshift(selectionColumn);
      }
    }
    return columns;
  }
  render() {
    const pagination = this.renderPagination();
    return /*#__PURE__*/createElement(TableWrapperDiv, null, /*#__PURE__*/createElement(ContainerDimensions, null, ({
      height
    }) => this.renderTable(height, pagination !== null)), pagination);
  }
}
_defineProperty(BaseTable, "Column", Column);
_defineProperty(BaseTable, "defaultProps", {
  prefixCls: 'danfoss-table',
  dataSource: [],
  size: 'default',
  loading: false,
  rowKey: 'key',
  sortDirections: ['ascend', 'descend'],
  checkboxPropsCache: {},
  styles: {
    root: {
      bg: 'white'
    }
  }
});

export default BaseTable;
